// src/app/educator/email-verified/page.tsx
"use client";

import { Button, Result } from "antd";
import { CheckCircle } from "lucide-react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function EmailVerifiedPage() {
  const router = useRouter();

  useEffect(() => {
    // Update application status in parent window if opened in popup
    if (window.opener) {
      window.opener.postMessage("email-verified", window.location.origin);
      window.close();
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <Result
        icon={<CheckCircle className="h-16 w-16 text-green-500" />}
        title="Email Verified Successfully!"
        subTitle="You can now continue with your educator program application."
        extra={[
          <Button
            key="continue"
            type="primary"
            onClick={() => router.push("/educators/apply")}
            className="bg-teal-600 hover:bg-teal-700"
          >
            Continue Application
          </Button>,
        ]}
      />
    </div>
  );
}
